import { call, take, put } from 'redux-saga/effects';
import { get, putMethod } from '../../utils/api';
import settings from '../../utils/settings';

import {
  PREFERENCES_REQUEST,
  PREFERENCES_SUCCESS,
  UPDATE_PREFERENCES_REQUEST,
  UPDATE_PREFERENCES_SUCCESS,
  REQUEST_FAILURE,
  GET_USER_OWN_PREFERENCES_REQUEST,
  GET_USER_OWN_PREFERENCES_SUCCESS,
  GET_USER_OWN_PREFERENCES_FAILURE,
  PREFERENCES_WITHOUT_SITES_REQUEST,
  PREFERENCES_WITHOUT_SITES_SUCCESS,
  REQUEST_WITHOUT_SITES_FAILURE
} from './constants';

export function* getUserPreferences() {
  while (true) {
    yield take(PREFERENCES_REQUEST);
    try {
      let response;
      response = yield call(get, {
        url: settings.getApiUrl(`service/enlm_ms/api_internal/account/preferences`)
      });
      if (response.success) {
        const { alert_preferences_by_system, master_data, ...preferencesData } = response.result;
        yield put({
          type: PREFERENCES_SUCCESS,
          preferencesData: preferencesData,
          masterData: master_data,
          alertPreferencesBySystem: alert_preferences_by_system
        });
      } else {
        yield put({ type: REQUEST_FAILURE, error: response.result.message || response.result.messages });
      }
    } catch (error) {
      console.log('Saga: getUserPreferences:', error);
      yield put({ type: REQUEST_FAILURE, error: error });
    }
  }
}

export function* getUserPreferencesWithoutSites() {
  while (true) {
    yield take(PREFERENCES_WITHOUT_SITES_REQUEST);
    try {
      let response;
      response = yield call(get, {
        url: settings.getApiUrl(`service/enlm_ms/api_internal/account/user_preference_flags`)
      });
      if (response.success) {
        const { master_data, ...preferencesData } = response.result;
        yield put({
          type: PREFERENCES_WITHOUT_SITES_SUCCESS,
          preferencesDataWithoutSites: preferencesData,
          masterDataWithoutSites: master_data,
        });
      } else {
        yield put({ type: REQUEST_WITHOUT_SITES_FAILURE, error: response.result.message || response.result.messages });
      }
    } catch (error) {
      // console.log('Saga: getUserPreferencesWithoutSites:', error);
      yield put({ type: REQUEST_WITHOUT_SITES_FAILURE, error: error });
    }
  }
}

export function* updateUserPreferences() {
  while (true) {
    const request = yield take(UPDATE_PREFERENCES_REQUEST);
    try {
      let response;
      const { body = {}, successCbk, isSystemUpdate = false } = request.payload;
      const url = settings.getApiUrl(`service/enlm_ms/api_internal/account${isSystemUpdate ? '/site-level-preferences' : ''}`);
      response = yield call(putMethod, {
        url,
        body
      });
      if (response.success) {
        yield put({ type: UPDATE_PREFERENCES_SUCCESS, body, message: response.result.message });
        successCbk();
      } else {
        yield put({ type: REQUEST_FAILURE, error: response.result.message || response.result.messages });
      }
    } catch (error) {
      console.log('Saga: updateUserPreferences:', error);
      yield put({ type: REQUEST_FAILURE, error: error });
    }
  }
}

export function* getUserOwnPreferencesFlow() {
  while (true) {
    yield take(GET_USER_OWN_PREFERENCES_REQUEST);
    try {
      let response;
      response = yield call(get, {
        url: settings.einCoreUrl(`user/preferences`),
        withBearer: true
      });
      if (response.success) {
        const {
          alert_level,
          enphase_email,
          lead_email,
          metric,
          monthly_email,
          new_dashboard_view,
          solargraf_access
        } = response.result;
        const preferencesData = {
          prefers_enphase_email: enphase_email,
          prefers_monthly_email: monthly_email,
          preferred_alert_level: alert_level,
          preferred_lead_email: lead_email,
          preferred_metric: metric,
          preferred_new_dashboard_view: new_dashboard_view
        };
        yield put({
          type: GET_USER_OWN_PREFERENCES_SUCCESS,
          preferencesData: preferencesData,
          solargrafAccess: solargraf_access
        });
      } else {
        yield put({
          type: GET_USER_OWN_PREFERENCES_FAILURE,
          error: response.result.message || response.result.messages
        });
      }
    } catch (error) {
      console.log('Saga: getUserOwnPreferences:', error);
      yield put({ type: GET_USER_OWN_PREFERENCES_FAILURE, error: error });
    }
  }
}
